import { SelectedCompanyStatus } from '@features/SharedList/constants'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'
export interface IChangeStatusPayload {
    sharedListId: string
    data: {
        company: string
        status: keyof typeof SelectedCompanyStatus
    }
    sagaCB?: any
}

export interface IChangeStatusState {
    status: string
    data: any
    errors: any
}

const initialState: IChangeStatusState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const changeStatus = createSlice({
    name: 'sharedList/change-status',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IChangeStatusPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const changeStatusActions = changeStatus.actions
export default changeStatus.reducer
